module.exports = __webpack_public_path__ + "img/create.b96911d9.png";